<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <h3>{{title}}</h3>
  </div>

  <span *ngIf="!loading" class="close-dialog" mat-dialog-close>
      <i class="material-icons">close</i>
    </span>
</div>
<div *ngIf="loading">
  <div class="loader"></div>
  <p class="txt-loader mb-30">Please wait until the survey date is updated ...</p>
</div>
<div *ngIf="!loading">
  <mat-card class="row d-flex justify-content-center inline-calendar-card">
    <mat-calendar #calendar
                  class="col-md-12"
                  [startAt]="selected"
                  [(selected)]="selected"
                  [maxDate]="this.surveyDate === 'startDate'?oppositeDate:null"
                  [minDate]="this.surveyDate === 'endDate'?oppositeDate:null"
    ></mat-calendar>
  </mat-card>
  <div class="row">
    <div class="col-md-12 mt-10">
      <div class="text-center">
        <cmp-button class="outline-primary" text="Today" (onClick)="onTodayDate()"></cmp-button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!loading" class="float-right mt-30">
  <cmp-button text="Set" (onClick)="onChangeSurveyDate()"></cmp-button>
</div>
